<script>
export default {
  name: "DidoChipsList",
};
</script>

<script setup>
import DidoChip from "./Chip.vue";

// define Props
const props = defineProps({
  items: { type: Array, required: true },
  type: { type: String, required: true },
  fromDatasetOrDatafile: { type: String, required: true },
  size: { type: String, required: false, default: "sm" },
  outline: { type: Boolean, required: false, default: false },
  bgColor: { type: String, required: false, default: "secondary" },
  textColor: { type: String, required: false, default: "white" },
  icon: { type: String, required: false, default: null },
});

// define events emitted
const emit = defineEmits(["label-selection"]);
</script>

<template>
  <span>
    <DidoChip
      v-for="item in props.items"
      :key="item.id"
      :type="props.type"
      :from-dataset-or-datafile="props.fromDatasetOrDatafile"
      :item="item"
      :size="props.size"
      :color="props.bgColor"
      :text-color="props.textColor"
      :outline="props.outline"
      :icon="props.icon"
      @label-selection="($event) => emit('label-selection', $event)"
    />
  </span>
</template>
